import React, { useState, useContext } from "react";
import Bitewelcome from "../../../assets/Bitewelcome.png";
import Rectangle3 from "../../../assets/Rectangle3.svg";
import Rectangle13 from "../../../assets/Rectangle13.svg";
import {
  Box,
  Typography,
  styled,
  CssBaseline,
  ThemeProvider,
  Button,
  OutlinedInput,
  useMediaQuery,
  FormGroup,
} from "@mui/material";
import theme from "../../../config/theme";
import { StyledButton } from "../../../components/common/Button";
import { StyledFormControl } from "../../../components/common/FormControl";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Auth } from "aws-amplify";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import UserContext from "../../../contexts/user";

const StyledBox1 = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "3.3125rem",
  marginLeft: "3.75rem",
  marginRight: "3.75rem",
  borderRadius: "1.25rem",
  height: "38.8125rem",
  backgroundImage: `url(${Rectangle3})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% auto",
  backgroundPosition: "center",
  padding: "2rem",
});

const StyledBox = styled(Box)({
  textAlign: "center",
  height: "31.3125rem",
  width: "32rem",
  background: "#FFFFFF",
  borderRadius: "1.25rem",
  boxShadow: "0px 8px 24px rgba(88, 101, 242, 0.15)",
});

const StyledBox2 = styled(Box)({
  display: "flex",
  flexDirection: "column",
  marginTop: "2rem",
  marginLeft: "0.25rem",
  marginRight: "0.25rem",
  borderRadius: "0.75rem",
  height: "42.625rem",
  backgroundImage: `url(${Rectangle13})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "100% auto",
  backgroundPosition: "center",
});

const StyledBox3 = styled(Box)({
  textAlign: "center",
  height: "21.375rem",
  width: "21.875rem",
  background: "#FFFFFF",
  borderRadius: "0.5rem",
  boxShadow: "0px 5.46875px 16.4063px rgba(88, 101, 242, 0.15)",
  marginTop: "3.75rem",
});

const Welcome = () => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const { enqueueSnackbar } = useSnackbar();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { setUser, setUserRole } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const signIn = async () => {
    setLoading(true);
    try {
      const user = await Auth.signIn(formData.email, formData.password);
      setUser(user);
      setUserRole(user.attributes["custom:type"]);
      setLoading(false);
    } catch (e) {
      console.log("Signin: Error", e);
      enqueueSnackbar("Incorrect username or password", { variant: "error" });
      setLoading(false);
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {isMobile ? (
        <StyledBox2>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <StyledBox3>
              <Typography
                variant="h4"
                sx={{
                  marginTop: "2.246875rem",
                  fontWeight: 600,
                  fontSize: "1.375rem",
                  color: "#212121",
                  letterSpacing: "0.010681125rem",
                }}
              >
                Welcome Back!
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  marginTop: "0.75rem",
                  fontWeight: 400,
                  fontSize: "0.75rem",
                  color: "#6A6A6A",
                  letterSpacing: "0.0064086875rem",
                }}
              >
                Login to your account
              </Typography>
              <FormGroup sx={{ alignItems: "center" }}>
                <StyledFormControl
                  sx={{
                    marginTop: "2.5rem",
                    height: "2rem",
                    width: "14.375rem",
                    background: "#E3FEEE",
                    border: "0.683594px solid #0C9D46",
                    borderRadius: "0.341796875rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <EmailIcon
                      sx={{
                        height: "1.0625rem",
                        width: "0.8125rem",
                        marginLeft: "0.650625rem",
                        color: "#0C9D46",
                      }}
                    />
                    <OutlinedInput
                      placeholder="abcd@gmail.com"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        color: "#6A6A6A",
                        letterSpacing: "0.0064086875rem",
                      }}
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </Box>
                </StyledFormControl>
                <StyledFormControl
                  sx={{
                    marginTop: "0.75rem",
                    height: "2rem",
                    width: "14.375rem",
                    background: "#EEF6FF",
                    border: "0.683594px solid #6A6A6A",
                    borderRadius: "0.341796875rem",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <LockIcon
                      sx={{
                        height: "1.0625rem",
                        width: "0.6875rem",
                        marginLeft: "0.693125rem",
                        color: "#0C9D46",
                      }}
                    />
                    <OutlinedInput
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      sx={{
                        fontWeight: 600,
                        fontSize: "0.75rem",
                        color: "#6A6A6A",
                        letterSpacing: "0.0064086875rem",
                      }}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <VisibilityIcon
                      onClick={handleTogglePassword}
                      sx={{
                        height: "1.0625rem",
                        width: "0.875rem",
                        marginRight: "0.421875rem",
                        color: "#0C9D46",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </StyledFormControl>
              </FormGroup>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "0.310625rem",
                  marginRight: "4.29375rem",
                }}
              >
                <Button
                  sx={{
                    color: "#0C9D46",
                    cursor: "pointer",
                    fontSize: "0.625rem",
                    fontWeight: 700,
                    letterSpacing: "0.0534058125rem",
                  }}
                >
                  Forgot Password?
                </Button>
              </Box>

              <StyledButton
                style={{
                  backgroundColor: "#0C9D46",
                  height: "2rem",
                  width: "14.375rem",
                  marginTop: "0.814375rem",
                  borderRadius: "1.02539375rem",
                  color: "#FFFFFF",
                  letterSpacing: "0.0534058125rem",
                  fontSize: "0.625rem",
                  fontWeight: 700,
                }}
              >
                LOGIN
              </StyledButton>

              <Box
                sx={{
                  display: "flex",
                  marginTop: "1.111875rem",
                  marginLeft: "4.30875rem",
                  marginBottom: "2.515625rem",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#212121",
                    fontWeight: 400,
                    fontSize: "0.625rem",
                    letterSpacing: "0.0064086875rem",
                  }}
                >
                  Not Registered Yet?
                </Typography>
                <Button
                  sx={{
                    color: "#0C9D46",
                    cursor: "pointer",
                    fontWeight: 400,
                    fontSize: "0.625rem",
                    letterSpacing: "0.0064086875rem",
                  }}
                >
                  Create an account
                </Button>
              </Box>
            </StyledBox3>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={Bitewelcome}
              alt=""
              style={{
                objectFit: "contain",
                height: "6.875rem",
                width: "10.375rem",
                marginTop: "3.75rem",
              }}
            />
          </Box>
          <Box
            sx={{
              marginTop: "3.25rem",
              marginLeft: "1.25rem",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                fontWeight: 700,
                fontSize: "1.375rem",
                color: "#0C9D46",
              }}
            >
              Bite
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                fontSize: "0.625rem",
                color: "#212121",
                marginTop: "0.32875rem",
              }}
            >
              By Youstad
            </Typography>
          </Box>
        </StyledBox2>
      ) : (
        <StyledBox1>
          <Box sx={{ height: "38.8125rem" }}>
            <Box
              sx={{
                objectFit: "contain",
                height: "21.5rem",
                width: "26.5rem",
                marginTop: "9.125rem",
              }}
            >
              <img src={Bitewelcome} alt="" />
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  fontSize: "3rem",
                  color: "#0C9D46",
                  marginTop: "3rem",
                }}
              >
                Bite
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 400,
                  fontSize: "1.25rem",
                  color: "#212121",
                  marginTop: "0.75rem",
                }}
              >
                By Youstad
              </Typography>
            </Box>
          </Box>
          <StyledBox>
            <Typography
              variant="h4"
              sx={{
                marginTop: "3.25rem",
                fontWeight: 600,
                fontSize: "1.875rem",
                color: "#212121",
                letterSpacing: "0.015625rem",
              }}
            >
              Welcome Back!
            </Typography>
            <Typography
              variant="h6"
              sx={{
                marginTop: "1.25rem",
                fontWeight: 400,
                fontSize: "1.125rem",
                color: "#6A6A6A",
                letterSpacing: "0.009375rem",
              }}
            >
              Login to your account
            </Typography>
            <FormGroup sx={{ alignItems: "center" }}>
              <StyledFormControl
                sx={{
                  marginTop: "3.8125rem",
                  height: "3rem",
                  width: "21rem",
                  background: "#E4FFEF",
                  border: "1px solid #0C9D46",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <EmailIcon
                    sx={{
                      height: "1.5rem",
                      width: "1.125rem",
                      marginLeft: "0.9375rem",
                      color: "#0C9D46",
                    }}
                  />
                  <OutlinedInput
                    placeholder="abcd@gmail.com"
                    sx={{
                      flex: 1,
                    }}
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </Box>
              </StyledFormControl>
              <StyledFormControl
                sx={{
                  marginTop: "0.8125rem",
                  height: "3rem",
                  width: "21rem",
                  background: "#E4FFEF",
                  border: "1px solid #6A6A6A",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <LockIcon
                    sx={{
                      height: "1.5rem",
                      width: "1rem",
                      marginLeft: "1rem",
                      color: "#0C9D46",
                    }}
                  />
                  <OutlinedInput
                    type={showPassword ? "text" : "password"}
                    placeholder="Password"
                    sx={{
                      flex: 1,
                    }}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <VisibilityIcon
                    onClick={handleTogglePassword}
                    sx={{
                      height: "1.5rem",
                      width: "1.3125rem",
                      marginRight: "1.125rem",
                      color: "#0C9D46",
                      cursor: "pointer",
                    }}
                  />
                </Box>
              </StyledFormControl>
            </FormGroup>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                sx={{
                  color: "#0C9D46",
                  cursor: "pointer",
                  marginTop: "0.4375rem",
                  marginRight: "5.5rem",
                }}
              >
                Forgot Password?
              </Button>
            </Box>
            <Typography>
              <StyledButton
                style={{
                  backgroundColor: "#0C9D46",
                  height: "3rem",
                  width: "21rem",
                  marginTop: "1.25rem",
                  borderRadius: "1.5rem",
                  color: "#FFFFFF",
                  letterSpacing: "0.078125rem",
                }}
                onClick={signIn}
                disabled={loading}
              >
                {loading ? "Loading..." : "LOGIN"}
              </StyledButton>
            </Typography>
            <Box
              sx={{
                display: "flex",
                marginTop: "1.5rem",
                marginLeft: "7.1875rem",
                fontWeight: 400,
                fontSize: "0.875rem",
                letterSpacing: "0.009375rem",
                alignItems: "center",
              }}
            >
              <Typography sx={{ color: "#212121" }}>
                Not Registered Yet?
              </Typography>
              <Button
                sx={{
                  color: "#0C9D46",
                  cursor: "pointer",
                }}
              >
                Create an account
              </Button>
            </Box>
          </StyledBox>
        </StyledBox1>
      )}
    </ThemeProvider>
  );
};

export default Welcome;
